import React, { useState, useEffect, useRef } from "react";
import {
  InstantSearch,
  Hits,
  SearchBox,
  Pagination,
  Stats,
  Configure,
  connectStateResults
} from "react-instantsearch-dom";
import classNames from "classnames";
import ConditionalRender from "../utility/ConditionalRender";
import Hit from "./search-hit";
import IndexSelector from "./index-selector";
import styles from "./index.module.css";
import settings from "../../settings";

const SearchResults = ({ searchClient, visible, onToggleVisibility }) => {
  const thisSearch = useRef();
  const [displayResults, setDisplayResults] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(settings.indices[0]);
  const [searchValue, setSearchValue] = useState("");

  const searchWatcher = e => {
    setSearchValue(e.target.value);
    if (e.target && "value" in e.target && e.target.value.length >= 2) {
      setDisplayResults(true);
    } else {
      setDisplayResults(false);
    }
  };

  const onPaginate = () => {
    document.getElementById("gw-search-results").scrollTop = 0;
  };

  let defaultFilters = () => {
    return 'primary_sort_method:default AND NOT expiration_date:1 TO ' + (Date.now() / 1000);
  };

  useEffect(() => {
    if (!visible) return;
    thisSearch.current.querySelector(".ais-SearchBox-input").focus();
  }, [visible]);

  const ConditionalPagination = connectStateResults(({ searchResults }) =>
    searchResults && searchResults.nbHits > 0 ? (
      <Pagination showFirst={false} showLast={false} />
    ) : null
  );

  return (
    <InstantSearch searchClient={searchClient} indexName={currentIndex.index}>
      <Configure
        hitsPerPage={21}
        filters={defaultFilters()}
      />
      <div
        ref={thisSearch}
        className={classNames("search-panel", styles.searchResults)}
      >
        <div className="search-panel__results">
          <SearchBox
            className={classNames(
              styles.searchBox,
              "searchbox tw-mb-2 md:tw-mb-4"
            )}
            translations={{
              placeholder: ""
            }}
            onKeyUp={searchWatcher}
            autoFocus={false}
            defaultRefinement={searchValue}
          />

          <ConditionalRender shouldRender={displayResults}>
            <div className="md:tw-flex tw-items-start md:tw-items-center tw-justify-between md:tw-mb-6">
              {settings.indices.length > 1 && <IndexSelector
                currentIndex={currentIndex}
                onChange={index => setCurrentIndex(index)}
              />}

              <Stats
                className="tw-mb-2 md:tw-mb-0 tw-text-center tw-mt-0"
                translations={{
                  stats(nbHits, timeSpentMS) {
                    return (
                      <span>
                        <strong>{nbHits}</strong> results found
                      </span>
                    );
                  }
                }}
              />
            </div>
          </ConditionalRender>

          <div className={styles.searchResultsContainerWrapper}>
            <div
              id="gw-search-results"
              className={classNames(styles.searchResultsContainer, "tw-mb-4")}
            >
              <ConditionalRender shouldRender={displayResults}>
                <Hits hitComponent={Hit} />
              </ConditionalRender>
            </div>
          </div>

          <ConditionalRender shouldRender={displayResults}>
            <div className={styles.pagination} onClick={onPaginate}>
              <ConditionalPagination />
            </div>
          </ConditionalRender>
        </div>
      </div>
    </InstantSearch>
  );
};

export default React.memo(SearchResults);
